module.exports = require("core-js/modules/esnext.map.merge.js");